import { useState } from 'react';
import Button from '../../reusable/Button/Button';
import { t } from '../../i18n/i18n';
import '../../reusable/FilterDropdown/FilterDropdown.scss';
import './ColumnPicker.scss';

const icon = (name) => ({ '--icon': `url(/icons/${name}.svg)` });

/**
 * "Columns" — which of the payload's fields the trade table shows (TI review
 * N43). The menu is the toolbar filter's own (FilterDropdown's classes), with a
 * tick per column; a click toggles it and leaves the menu open, so several can
 * be switched in one go. The last visible column can't be hidden.
 */
export default function ColumnPicker({ columns, visible, onToggle, onReset }) {
  const [isOpen, setIsOpen] = useState(false);
  const shown = columns.filter((col) => visible.has(col.key)).length;

  return (
    <div className={`filter-dropdown-wrapper column-picker${isOpen ? ' ac-menu-open is-open' : ''}`}>
      <Button
        variant="toolbar"
        iconPlacement="end"
        icon={<span className="icon" style={icon('table-rows')} />}
        onClick={() => setIsOpen((open) => !open)}
        className={isOpen ? 'is-active' : ''}
        aria-expanded={isOpen}
      >
        {t('Columns ({{shown}}/{{total}})', { shown, total: columns.length })}
      </Button>

      {isOpen && (
        <div
          className="filter-dropdown-backdrop"
          onClick={() => setIsOpen(false)}
          style={{ position: 'fixed', inset: 0, zIndex: 99, background: 'transparent' }}
        />
      )}

      <div className={`filter-dropdown-menu column-picker__menu is-down is-align-right${isOpen ? ' is-open' : ''}`}>
        {columns.map((col) => {
          const on = visible.has(col.key);
          const last = on && shown === 1;
          return (
            <button
              key={col.key}
              type="button"
              role="menuitemcheckbox"
              aria-checked={on}
              disabled={last}
              className={`filter-dropdown-item${on ? ' is-selected' : ''}`}
              onClick={() => onToggle(col.key)}
            >
              <span className="filter-dropdown-item-label">{t(col.header)}</span>
              {on && <span className="icon filter-dropdown-item-check" style={icon('check-sm')} />}
            </button>
          );
        })}
        <button type="button" className="column-picker__reset" onClick={onReset}>
          {t('Show default columns')}
        </button>
      </div>
    </div>
  );
}
